var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: "template-view-area" } },
    [
      _vm.templateData
        ? _c(
            "sc-card",
            [
              _c(
                "template",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c("billing-template-summary", {
                    attrs: {
                      logisticProviderId: _vm.templateData.logisticProviderId,
                      templateName: _vm.templateData.name,
                      templateRowNumber: _vm.templateData.headerRow
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "section",
                    { class: _vm.gridSizeClass, attrs: { id: "fields-grid" } },
                    [
                      _c("div", { staticClass: "column-header" }, [
                        _vm._v("Nome do dado")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "column-header" }, [
                        _vm._v("Coluna")
                      ]),
                      _vm._v(" "),
                      _vm.containsPreview()
                        ? _c("div", { staticClass: "column-header" }, [
                            _vm._v("Nome do dado na fatura")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.columnsEnum, function(ref) {
                        var key = ref[0]
                        var value = ref[1]
                        return _vm.templateValues[key]
                          ? [
                              value.hasMultipleTypes
                                ? [
                                    _vm.templateValueIsPercentage[key] ===
                                    "true"
                                      ? _c(
                                          "div",
                                          { staticClass: "column-name" },
                                          [_vm._v(_vm._s(value.label) + " (%)")]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "column-name" },
                                          [
                                            _vm._v(
                                              _vm._s(value.label) + " (R$)"
                                            )
                                          ]
                                        )
                                  ]
                                : _c("div", { staticClass: "column-name" }, [
                                    _vm._v(_vm._s(value.label))
                                  ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "column-value" }, [
                                _vm._v(_vm._s(_vm.templateValues[key]))
                              ]),
                              _vm._v(" "),
                              _vm.templatePreview[key]
                                ? _c("div", { staticClass: "column-name" }, [
                                    _vm._v(_vm._s(_vm.templatePreview[key]))
                                  ])
                                : _vm._e()
                            ]
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b69bfb0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b69bfb0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/BillingTemplateViewMode.vue
// module id = null
// module chunks = 